import { useEffect } from 'react';
import { PageController } from '@sitecore-search/core';
import useBaseWidget from './useBaseWidget.js';
import useWidget from './useWidget.js';
import { useHandlerRef } from './utils.js';
const useWidgetActionsReducer = (reducer, deps) => {
    const control = useWidget();
    const { rfkId, instanceId } = useBaseWidget();
    const actionReducer = useHandlerRef(reducer, deps);
    useEffect(() => {
        const listener = {
            handleAction(action) {
                const { rfkId: id, instanceId: instance = null } = action.payload;
                if (id === rfkId && instanceId === instance) {
                    const newState = actionReducer.current(control.state, action);
                    if (newState !== control.state) {
                        control.updateState(newState);
                    }
                }
            },
        };
        PageController.register(listener);
        return () => PageController.unregister(listener);
    }, [rfkId, instanceId, control, actionReducer]);
};
export default useWidgetActionsReducer;
